<script lang="ts">
	import {
		BookSearchOutline,
		CarInfo,
		CarPickup,
		Check,
		CheckCircleOutline,
		CircleOutline,
		CloseIcon,
		Factory,
		InformationOutline,
		MinusCircle,
		OpenInNew,
		TriangleOutline,
		WeightGram,
	} from '../icons';
	import { Color } from '../scripts/color';
	import { is_2nd_store, jumpToScripLink } from '../scripts/util';

	const yahoo_shopping_base_url = import.meta.env.VITE_YAHOO_SHOPPING_SHOP_BASE_URL;
	const yahoo_auction_base_url = import.meta.env.VITE_YAHOO_AUCTION_SHOP_BASE_URL;
	const miyazeki_store_home_page = import.meta.env.VITE_MIYAZEKI_STORE_HOME_PAGE;
	const parts_scrip_page = import.meta.env.VITE_SCRIP_BASE_LINK;

	export let analysis_result: type_service_search_result;
	export let vin: string;

	function jumpToShopLink(mode: 'A' | 'S', item_code: string) {
		// let star_prefix = is_2nd_store ? '' : '★';

		// const base_url = mode === 'A' ? `${yahoo_auction_base_url}${star_prefix}${item_code}` : `${yahoo_shopping_base_url}${item_code.toLowerCase()}.html`;
		// const target_link = encodeURI(base_url);

		const target_link = mode === 'A' ? `${yahoo_auction_base_url}${item_code}`:`${yahoo_shopping_base_url}${item_code}`
		// console.log(target_link);
		window.open(target_link, '_blank');
	}
</script>

<div class="card-body">
	{#if analysis_result.analysis.parts && analysis_result.analysis.parts.length > 0}
		<div class="adapted-info columns fl">
			<BookSearchOutline size="1.5em" />
			<b class="h5">適合情報</b>
		</div>
		<ul class="result-messages">
			{#each analysis_result.messages as message}
				<li>{message}</li>
			{/each}
		</ul>
		<div class="panel">
			<div class="panel-body">
				<div class="parts-info">
					{#each analysis_result.analysis.parts as target_row}
						<!-- class:non-adapted-panel={target_row.adapted && (target_row.target_row_condition.length > 0 || target_row.target_row_annotation.length > 0)} -->
						<div class="conformity-panel my-2" class:adapted-panel={target_row.adapted && target_row.target_row_condition.length === 0 && target_row.target_row_annotation.length === 0}>
							<table class="table">
								<tr>
									<th class="item-code">コード</th>
									<td class="item-code">{target_row.item_code}</td>
									<th class="adapt">適合</th>
									<td class="adapt">
										<div
											class="border-chip"
											class:sun={target_row.adapted && (target_row.target_row_condition.length > 0 || target_row.target_row_annotation.length > 0)}
											class:teal={target_row.adapted && target_row.target_row_condition.length === 0 && target_row.target_row_annotation.length === 0}
										>
											{#if target_row.adapted}
												{#if target_row.target_row_condition.length > 0 || target_row.target_row_annotation.length > 0}
													<TriangleOutline color={Color.sun} size="1.5em" />
													<b class="mt-1 ms-1 red">位置・条件確認</b>
												{:else}
													<CircleOutline color={Color.green} size="1.5em" />
													<b class="mt-1 ms-1 green">適合OK</b>
												{/if}
											{:else}
												<CloseIcon color={Color.dark_gray_lower} size="1.5em" />
												<b class="mt-1 ms-1">適合不可</b>
											{/if}
										</div>
									</td>
								</tr>
								<tr>
									<th class="item-name">商品名</th>
									<td class="item-name" colspan="3">{target_row.item_name}</td>
								</tr>
								{#if target_row.adapted}
									{#if target_row.target_row_condition.length > 0}
										<tr>
											<th class="condition">位置・条件</th>
											<td class="condition" colspan="3">{target_row.target_row_condition}</td>
										</tr>
									{/if}
									{#if target_row.target_row_annotation.length > 0}
										<tr>
											<th class="annotations">注記</th>
											<td class="annotations" colspan="3">{target_row.target_row_annotation}</td>
										</tr>
									{/if}
									<tr>
										<th class="link"> 販売リンク </th>
										<td class="link" colspan="3">
											<div class="fl a-end pb-2 link-btn-row">
												<button class="btn btn-azure fl" on:click={() => jumpToShopLink('A', target_row.item_code)}>
													<span>YAHOO!オークション</span>
												</button>
												<button class="ms-3 btn-with-signboard" on:click={() => jumpToShopLink('S', target_row.item_code)}>
													<div class="signboard">
														<span>ポイント<b>5%</b>還元</span>
													</div>
													<div class="btn btn-azure fl a-end pb-2">
														<span>YAHOO!ショッピング</span>
													</div>
												</button>
											</div>
										</td>
									</tr>
								{:else if is_2nd_store}
									<tr>
										<td class="to-parts-scrip" colspan="4">
											<button class="expand-switcher mt-1">
												<a href={parts_scrip_page + vin} target="_blank" class="fl" rel="noopener noreferrer">
													<span class="me-2">お車に適合する商品を探す</span>
													<img src="/partsscrip-link-miyazeki.png" alt="パーツチェッカーロゴ" />
												</a>
											</button>
											<!-- <div class="fl">
												<b class="ms-1">適合品はパーツスクリップで検索してください。</b>
												<button type="button" class="ms-auto me-2 btn btn-scrip fl" on:click={e => jumpToScripLink(vin)}>
													<span class="me-1">パーツスクリップへ</span>
													<OpenInNew />
												</button>
											</div> -->
										</td>
									</tr>
								{/if}
							</table>
						</div>
					{/each}
				</div>
			</div>
		</div>
	{/if}
</div>

<style lang="scss" scoped>
	@use '../sass/color.scss' as color;
	.card-body {
		.adapted-info {
			text-decoration: underline;
			b {
				text-decoration: underline;
			}
		}
	}
	.panel {
		.panel-body {
			overflow-y: unset;
			.parts-info {
				.conformity-panel {
					border-radius: 0.5rem;
					border: solid 1px;

					table {
						border-radius: 0.5rem;
						overflow: hidden;

						th {
							width: 100px;
							padding: 0.3rem 0.5rem;
							&.item-code {
								width: 70px;
							}
							&.adapt {
								width: 55px;
							}
							@media (max-width: 1000px) {
								width: 80px;
								padding: 0.2rem 0.3rem;
							}
						}
						td {
							padding: 0.3rem;
							&.link {
								.link-btn-row {
									height: 60px;
									// .btn-shopping {
									// 	background-color: #ff0033;
									// 	color: #fff;
									// 	border: none;
									// 	// width: 35px;
									// }
									// .btn-auction {
									// 	background-color: rgb(255, 218, 69);
									// 	color: #222;
									// 	border: none;
									// 	// width: 35px;
									// }
									.btn-with-signboard {
										position: relative;
										background-color: transparent;
										outline: none;
										border: none;
										padding: 0;

										.signboard {
											font-size: 0.6rem;
											border: solid 2px color.$azure;
											background-color: #ffff00;
											color: #ff0000;
											position: absolute;
											top: -30%;
											width: 98%;
											left: 1%;
											line-height: 1;
											font-weight: bold;
											b {
												font-size: 1.25em;
											}
										}
										.btn-azure {
											font-size: 0.75rem;
											line-height: 1;
										}
									}
								}
							}

							&.item-code {
								width: 60px;
							}
							&.to-parts-scrip {
								.expand-switcher {
									font-size: 1.2em;
								}
							}
							@media (max-width: 1000px) {
								padding: 0.2rem;
								&.item-code {
									width: 40px;
								}
							}
						}
					}

					&.adapted-panel {
						border: solid 1px color.$teal;
					}
					// &.non-adapted-panel {
					// 	border: solid 1px color.$sun;
					// }
				}
			}

			@media (max-width: 1000px) {
				padding: 0;
			}
		}
	}
</style>
